export const isProd = window.location.host.includes('prod') || window.location.host === 'app.green-triangle.com';

export const isLocalhost = window.location.host.startsWith('localhost:');
export const isDev = isLocalhost;

export const versionStr = '2025.x.28.';
